import 'assets/styles/compliance.scss';

import React, { useEffect, useState } from 'react';

import AnnouncementOutlinedIcon from '@material-ui/icons/AnnouncementOutlined';
import { useHistory } from 'react-router-dom';
import {useStore} from "../../hooks";
import {useSnackbar} from "notistack";
import * as config from "../../config/constants";
import { format } from 'date-fns';
import useDashboardStyles from 'assets/styles/useDashboardStyles';

const IssueManagementDashboard = ({ embedded = false}) => {
  const history = useHistory();
  const classes = useDashboardStyles();
  const [microRegulatoryProcessNext, setMicroRegulatoryProcessNext] = useState('');
  const [microRegulatoryProcessData, setMicroRegulatoryProcessData] = useState();
  const [microRegulatoryProcessCount, setMicroRegulatoryProcessCount] = useState(0);
  const [microRegulatoryProcessDisplayCount, setMicroRegulatoryProcessDisplayCount] = useState(0);
  const [microRegulatoryProcessLoading, setMicroRegulatoryProcessLoading] = useState(false);
  const store = useStore();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {}, []);
  const numRecordPage = embedded ? 5 : config.pageSize;

  const getMicroRegulatoryProcessList = async () => {
    try {
      const { data } = await store.api.getMicroProcessesFailed(numRecordPage);
      setMicroRegulatoryProcessData(data.results);
      setMicroRegulatoryProcessNext(data.next);
      setMicroRegulatoryProcessCount(data.count);
      data.count > numRecordPage
        ? setMicroRegulatoryProcessDisplayCount(numRecordPage)
        : setMicroRegulatoryProcessDisplayCount(data.count);
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    }
  };
 const getNextMicroRegulatoryProcesses = async () => {
    try {
      setMicroRegulatoryProcessLoading(true);
      const { data } = await store.api.getNextDataWithURL(microRegulatoryProcessNext);
      let newMicroRegulatoryProcesses = microRegulatoryProcessData;
      setMicroRegulatoryProcessNext(data.next);
      setMicroRegulatoryProcessData(undefined);
      const arrayLength = data.results.length;
      data.results.map((process, i) => {
        newMicroRegulatoryProcesses.push(process);
        if (arrayLength === i + 1) {
          setMicroRegulatoryProcessData(newMicroRegulatoryProcesses);
          setMicroRegulatoryProcessDisplayCount(microRegulatoryProcessDisplayCount + arrayLength);
        }
      });
    } catch (error) {
      setMicroRegulatoryProcessLoading(false);
      console.log(error);
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setMicroRegulatoryProcessLoading(false);
    }
  };

  useEffect(() => {
    getMicroRegulatoryProcessList();
  }, []);

  const navigateToMicroRegulatoryProcess = (microProcessId) => {
    const path = 'user-micro-regulatory-process-detail?micro_process='+microProcessId;
    history.push(path);
  };

  return (
    <section className={'compliance-container'}
       style={embedded ? { width: '100%', position: 'relative', left: '10px' } : undefined
    }>
     {!embedded && ( <div className="back-nav" onClick={() => history.push('/companies-dashboard')}>
        Home
      </div> )}
      <div className={classes.headerWrapper}>
        <AnnouncementOutlinedIcon className={classes.headerIcon} />
        <h4 className={classes.headerTitle}>Task/Issue Management Dashboard</h4>

      </div>

      <ul className="categories-list">
        <li key="count" style={{ backgroundColor: '#f4f5f7' }}>
          {!embedded && (
            <div>
            <div>The following screen lists all the Regulatory Micro-processes that have passed their Review Date and not been actioned or have failed the daily Automated Compliance testing.&nbsp; &nbsp;</div>
            <div>&nbsp;</div>
            <div><strong>ACTION</strong>: Process Owners will be responsible for Reviewing the issues and resolving them.</div>
            <div><strong>RESULT</strong>: Regulatory Micro-processes will be removed from this screen when they have passed validation and return to their Original Compliance Monitoring Programme.</div>
            <div>&nbsp;</div>
            </div>)}
           <div className={classes.statusTextWrapper}>
            <span className={classes.statusText}>
              Displaying {microRegulatoryProcessDisplayCount} of {microRegulatoryProcessCount} Micro Regulatory Processes
            </span>
          </div>
        </li>
          {microRegulatoryProcessData !== undefined &&
          microRegulatoryProcessData.map((microProcess, i) => {
            const microProcessId = microProcess.id;
            return (
                <li
                  key={i}
                  className={classes.listItem}
                  onClick={() => navigateToMicroRegulatoryProcess(microProcessId)}
                >
                  <span className={classes.field}>{microProcessId}</span>
                  <span className={`${classes.field} ${classes.name}`}>
                    {microProcess.micro_regulatory_process.name}
                  </span>
                  <span className={`${classes.field} ${classes.owner}`}>
                    {microProcess.owner.first_name} {microProcess.owner.last_name}
                  </span>
                  <span className={`${classes.field} ${classes.date}`}>
                      {format(new Date(microProcess.last_updated), 'yyyy-MM-dd HH:mm:ss')}

                  </span>
                  {!embedded && (<span
                    className={`${classes.status} ${
                      microProcess.validation_status === 'Passed' ? 'status green-status' : 'status red-status'
                    }`}
                  />)}
                  {embedded && (
                   <span
                      className={`${classes.status} ${
                        microProcess.validation_status === 'Passed' ? classes.greenStatus : classes.redStatus
                      }`}
                    />
                    )
                  }
                </li>
            );
          })}
        {microRegulatoryProcessCount > 10 && (
          <li className="get-next" key="next" onClick={() => getNextMicroRegulatoryProcesses()}>
            <span>{microRegulatoryProcessLoading ? 'Loading...' :  'Load ' + numRecordPage.toString() + ' more'}</span>
          </li>
        )}
      </ul>
    </section>
  );
};
IssueManagementDashboard.defaultProps = {};

export default IssueManagementDashboard;
